import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { LoginRequest, TokenResponse, AdminUser } from '../models';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private tokenKey = 'admin_token';
  private userSubject = new BehaviorSubject<AdminUser | null>(null);
  user$ = this.userSubject.asObservable();

  constructor(private http: HttpClient, private router: Router) {}

  get token(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  get isAuthenticated(): boolean {
    return !!this.token;
  }

  get isAdmin(): boolean {
    return this.userSubject.value?.role === 'admin';
  }

  login(credentials: LoginRequest): Observable<TokenResponse> {
    return this.http.post<TokenResponse>(`${environment.apiUrl}/auth/login`, credentials).pipe(
      tap((res) => {
        localStorage.setItem(this.tokenKey, res.access_token);
        this.loadUser();
      })
    );
  }

  loadUser(): void {
    if (!this.token) return;
    this.http.get<AdminUser>(`${environment.apiUrl}/auth/me`).subscribe({
      next: (user) => this.userSubject.next(user),
      error: () => this.logout(),
    });
  }

  logout(): void {
    localStorage.removeItem(this.tokenKey);
    this.userSubject.next(null);
    this.router.navigate(['/login']);
  }
}
